const config = {
  apiUrl: process.env.REACT_APP_CLIENT_API_URL,
  appUrl: process.env.REACT_APP_URL,
}

module.exports = config

